import { useContext, useEffect, useState } from 'react';
import { TanqueContext, TanqueContextC } from '../../contexts/contextTanque';
import {
  ModalAlert,
  ModalConfirmController,
  ModalValulaStyled,
  ModlaStatusStyled,
  StyledModalVazao,
} from '../../styles/modals';
import { IoCloseCircle } from 'react-icons/io5';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import zoomPlugin from 'chartjs-plugin-zoom';
import { format } from 'date-fns';
import { GraficosTankes } from '../../styles/graficos';
import { RiCloseCircleFill } from 'react-icons/ri';
import Calendar from 'react-calendar';
import { PiCalendarBlankThin } from 'react-icons/pi';
import { apiJalles } from '../../services/api';
import { HomeContext } from '../../contexts/contexHome';
import { IoIosArrowForward, IoIosArrowBack, IoMdCloseCircleOutline } from 'react-icons/io';
import { toast } from 'react-toastify';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin,
  ChartDataLabels,
);

export const ModalStatus = ({ statusTanque }) => {
  const { modalStatus, setModalStatus } = useContext(TanqueContext);

  return (
    <ModlaStatusStyled onClick={() => setModalStatus(!modalStatus)}>
      <div
        className="conteiner"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <span className="fecharModal" onClick={() => setModalStatus(!modalStatus)}>
          x
        </span>
        <ul>
          {statusTanque.map((status) => {
            return (
              <li key={status.id}>
                <div>
                  <span> {status.nome}</span>
                  <span>{status.status ? 'Ativado' : 'Desativado'}</span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </ModlaStatusStyled>
  );
};

export const ModalAlertas = () => {
  const { modalAlertas, setModalAlertas } = useContext(TanqueContextC);

  const { headerApi } = useContext(HomeContext);
  const [pageNumber, setPageNumber] = useState(1);

  const [alertas, setAlertas] = useState([]);
  const idUnidade = sessionStorage.getItem('connectionsUnitId');

  const listAlertasTanque = async () => {
    try {
      const response = await apiJalles.get(`/alertas/tanque/Leitura/${idUnidade}`, headerApi);
      setAlertas(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const alterPage = async (url) => {
    try {
      const response = await apiJalles.get(
        `/alertas/tanque/Leitura/${idUnidade}/${url}`,
        headerApi,
      );

      setAlertas(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    listAlertasTanque();
  }, []);

  return (
    <ModalAlert>
      <div className="conteiner">
        <IoCloseCircle className="closeBotao" onClick={() => setModalAlertas(!modalAlertas)} />
        <div className="headerModal">
          <span>Usuário</span>
          <span>Data</span>
          <span>Alerta</span>
          <span>Horário</span>
        </div>
        <ul>
          {alertas.results &&
            alertas.results.map((alerta) => {
              const data = new Date(alerta.createdAt);

              // Data no formato DD/MM/YYYY
              const dia = data.toLocaleDateString('pt-BR');

              // Hora no formato HH:MM
              const hora = data.toLocaleTimeString('pt-BR', {
                hour: '2-digit',
                minute: '2-digit',
              });
              return (
                <li>
                  <span>{alerta.usuario.nome}</span>
                  <span>{dia}</span>
                  <span>{alerta.mensagem}</span>
                  <span>{hora}</span>
                </li>
              );
            })}
        </ul>
        <div className="setasPaginacao">
          <button
            className={alertas.previous === null && 'disable'}
            disabled={alertas.previous === null}
            onClick={() => {
              setPageNumber(pageNumber - 1);
              alterPage(alertas.previous);
            }}
          >
            <IoIosArrowBack />
          </button>
          <section>{pageNumber}</section>
          <button
            className={alertas.next === null && 'disable'}
            disabled={alertas.next === null}
            onClick={() => {
              setPageNumber(pageNumber + 1);
              alterPage(alertas.next);
            }}
          >
            <IoIosArrowForward />
          </button>
        </div>
      </div>
    </ModalAlert>
  );
};

export const ModalConfimacaoBombaJM = ({ mensagem }) => {
  const { setModalConfimationBomba, ligarBombasJM, salveBombaFuntion } = useContext(TanqueContext);

  const lidarButtonBomba = (bomba, id) => {
    if (bomba === 'bomba1') {
      const data = {
        bomba1: true,
      };

      ligarBombasJM(data, id);
    } else {
      const data = {
        bomba2: true,
      };

      ligarBombasJM(data, id);
    }
  };

  return (
    <ModalConfirmController>
      <div className="deleteContact">
        <h2>{`Tem certeza de que deseja ${mensagem}`}</h2>
        <div>
          <button
            className="buttonYes"
            onClick={() => lidarButtonBomba(salveBombaFuntion[0], salveBombaFuntion[1])}
          >
            Sim
          </button>
          <button onClick={() => setModalConfimationBomba(false)}>Não</button>
        </div>
      </div>
    </ModalConfirmController>
  );
};

export const ModalConfimacaoBombaUol = ({ mensagem }) => {
  const { setModalConfimationBomba, ligarBombasUol, salveBombaFuntion } = useContext(TanqueContext);

  const lidarButtonBomba = (bomba, id) => {
    let data;
    switch (bomba) {
      case 'bomba1':
        data = { bomba1: true };
        break;
      case 'bomba2':
        data = { bomba2: true };
        break;
      case 'bomba3':
        data = { bomba3: true };
        break;
      default:
        throw new Error('Tipo de bomba inválido');
    }
    ligarBombasUol(data, id);
  };

  return (
    <ModalConfirmController>
      <div className="deleteContact">
        <h2>{`Tem certeza de que deseja ${mensagem}`}</h2>
        <div>
          <button
            className="buttonYes"
            onClick={() => lidarButtonBomba(salveBombaFuntion[0], salveBombaFuntion[1])}
          >
            Sim
          </button>
          <button onClick={() => setModalConfimationBomba(false)}>Não</button>
        </div>
      </div>
    </ModalConfirmController>
  );
};

export const ModalValvula = ({ valor, id }) => {
  const { modalValvula, setModalValvula, ligarBombasUol } = useContext(TanqueContext);

  const [currentValue, setCurrentValue] = useState(valor);

  const handleChange = (event) => {
    setCurrentValue(parseInt(event.target.value));
  };

  const newValueValvula = () => {
    const newData = {
      ValvulaAcionamento: currentValue,
    };
    ligarBombasUol(newData, id, ' ');
  };

  return (
    <ModalValulaStyled>
      <div className="conteiner">
        <h3>Alterar Válvula</h3>
        <div className="range">
          <input
            type="range"
            defaultValue={valor}
            value={currentValue}
            min={0}
            max={100}
            onChange={handleChange}
          />
          <span>{currentValue}%</span>
        </div>

        <div className="buttons">
          <button onClick={() => newValueValvula()}>Alterar</button>
          <button onClick={() => setModalValvula(!modalValvula)} className="cancel">
            Cancelar
          </button>
        </div>
      </div>
    </ModalValulaStyled>
  );
};

//=============================================================================================

export const ModalConfimacaoBombaTanque = ({ mensagem }) => {
  const { setModalConfimationBomba, idControlerBomba } = useContext(TanqueContextC);

  const lidarButtonBomba = async (id) => {
    const token = sessionStorage.getItem('connectionsToken');
    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const data = {
      comando: true,
    };

    try {
      await apiJalles.patch(`bomba/controle/${id}`, data, headerApi);
    } catch (error) {
    } finally {
      setModalConfimationBomba(false);
    }
  };

  return (
    <ModalConfirmController>
      <div className="deleteContact">
        <h2>{`Tem certeza de que deseja ${mensagem}`}</h2>
        <div>
          <button className="buttonYes" onClick={() => lidarButtonBomba(idControlerBomba)}>
            Sim
          </button>
          <button onClick={() => setModalConfimationBomba(false)}>Não</button>
        </div>
      </div>
    </ModalConfirmController>
  );
};

export const GraficosTanquesC = ({ TanquesData }) => {
  // Extrair rótulos e níveis dos tanques dos dados fornecidos

  const tankLabels = (TanquesData || []).map((tank) => tank.nome_tanque);

  const tankLevels = (TanquesData || []).map((tank) => tank.nivel_atual);

  // Opções de zoom para o gráfico
  const zoomOptions = {
    pan: {
      enabled: true,
      mode: 'x',
    },
    zoom: {
      wheel: {
        enabled: true,
      },
      pinch: {
        enabled: true,
      },
      mode: 'x',
    },
  };

  // Configurações gerais do gráfico
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        display: false,
        labels: {
          color: '#e7e0e0', // Cor do texto do rótulo do conjunto de dados
          font: {
            size: 16, // Tamanho da fonte do texto do eixo y
          },
        },
      },
      title: {
        display: false,
      },
      datalabels: {
        display: true,

        formatter: (value) => `${value}%`,
        font: {
          size: 12,
          weight: 'bold',
        },
        color: '#ffffff',
      },
      zoom: zoomOptions,
    },

    scales: {
      x: {
        ticks: {
          color: '#bababa',
        },
        grid: {
          color: '#e0e0e01a',
          borderColor: '#d3d3d319',
        },
      },
      y: {
        min: 0,
        max: 100,
        ticks: {
          color: '#979797',
        },
        grid: {
          color: '#e0e0e029',
          borderColor: '#d3d3d31f',
        },
      },
    },
  };

  // Estrutura de dados para o gráfico
  const data = {
    labels: tankLabels,
    datasets: [
      {
        label: 'Nível do Tanque',
        data: tankLevels,
        backgroundColor: 'rgba(157, 157, 157, 0.706)',
        borderColor: 'rgba(93, 93, 93, 0.559)',
        borderWidth: 1,
      },
    ],
  };

  return (
    <GraficosTankes>
      <h2>Níveis dos Tanques</h2>
      <Bar options={options} data={data} />
    </GraficosTankes>
  );
};

export const GraficosByTanque = ({ TanqueDataId }) => {
  const [historicoLabel, setHistoricoLabel] = useState([]);
  const [historicoData, setHistoricoData] = useState([]);
  const [calenderDate, setCalenderDate] = useState(new Date());
  const [selectDate, setSelectDate] = useState('dia');
  const [dateDay, setDateDay] = useState(new Date().getDate());
  const [modalCalender, setModalCalender] = useState(false);

  const listHistorico = async () => {
    const token = sessionStorage.getItem('connectionsToken');
    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    setHistoricoData([]);
    setModalCalender(false);
    setDateDay(calenderDate.getDate());
    try {
      const formatData = format(calenderDate, 'dd-MM-yyyy');

      const response = await apiJalles.get(
        `/historico/tanque/data/${TanqueDataId}/${formatData}/${selectDate}`,
        headerApi,
      );
      setHistoricoData(response.data);
      const newHistorico = response.data.map((historico) => {
        const date = new Date(historico.timestamp);
        const localDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));

        const dia = localDate.getDate().toString().padStart(2, '0');
        const mes = (localDate.getMonth() + 1).toString().padStart(2, '0');
        const ano = localDate.getFullYear();
        const hora = localDate.getHours().toString().padStart(2, '0');
        const minuto = localDate.getMinutes().toString().padStart(2, '0');

        const dataFormatada = `${dia}/${mes}/${ano} ${hora}:${minuto}`;

        return dataFormatada;
      });

      setHistoricoLabel(newHistorico);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    listHistorico();
  }, [TanqueDataId, selectDate, dateDay]);

  // Opções de zoom para o gráfico
  const zoomOptions = {
    pan: {
      enabled: true,
      mode: 'x',
    },
    zoom: {
      wheel: {
        enabled: true,
      },
      pinch: {
        enabled: true,
      },
      mode: 'x',
    },
  };

  // Configurações gerais do gráfico
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        display: false,
        labels: {
          color: '#e7e0e0', // Cor do texto do rótulo do conjunto de dados
          font: {
            size: 16, // Tamanho da fonte do texto do eixo y
          },
        },
      },
      title: {
        display: false,
      },
      datalabels: {
        display: true,

        formatter: (value) => `${value}%`,
        font: {
          size: 12,
          weight: 'bold',
        },
        color: '#ffffff',
      },
      zoom: zoomOptions,
    },

    scales: {
      x: {
        ticks: {
          color: '#bababa',
        },
        grid: {
          color: '#e0e0e01a',
          borderColor: '#d3d3d319',
        },
      },
      y: {
        min: 0,
        max: 100,
        ticks: {
          color: '#979797',
        },
        grid: {
          color: '#e0e0e029',
          borderColor: '#d3d3d31f',
        },
      },
    },
  };

  const data = {
    labels: historicoLabel,
    datasets: [
      {
        label: 'Nível do Tanque',
        data: historicoData.map((historico) => {
          return historico.nivel_atual;
        }),
        backgroundColor: 'rgba(157, 157, 157, 0.706)',
        borderColor: 'rgba(93, 93, 93, 0.559)',
        borderWidth: 1,
      },
    ],
  };

  return (
    <GraficosTankes>
      <div className="headerGrafic">
        <h2>Níveis dos Tanques</h2>
        <div className="neveisButton"></div>
      </div>
      {modalCalender && (
        <div className="calendarDiv">
          <span className="closeModal" onClick={() => setModalCalender(false)}>
            <RiCloseCircleFill />
          </span>
          <h3>Selecione uma data de histórico.</h3>
          <Calendar
            className="calendar"
            onChange={setCalenderDate}
            value={calenderDate}
            maxDate={new Date()}
          />
          <div className="buutons">
            <button onClick={() => listHistorico()}>Pesquisar</button>
            <button onClick={() => setModalCalender(false)}>Cancelar</button>
          </div>
        </div>
      )}
      <div className="conteinerIcon" onClick={() => setModalCalender(true)}>
        <PiCalendarBlankThin />
        <span>{dateDay}</span>
      </div>
      <div className="ListDate">
        <select name="selectdate" id="selectdate" onChange={(e) => setSelectDate(e.target.value)}>
          <option value="dia">Dia</option>
          <option value="mes">Mês</option>
          <option value="ano">Ano</option>
        </select>
      </div>
      {historicoData.length === 0 && (
        <div className="not404">
          <h2>Não existe histórico do Nível nessa data</h2>
        </div>
      )}
      <Bar options={options} data={data} />
    </GraficosTankes>
  );
};

export const VazaoModal = ({ vazao }) => {
  const { modalVazao, setModalVazao } = useContext(TanqueContextC);
  const [valor, setValor] = useState(vazao[1]);


  const lidarButtonBomba = async (id) => {
    const token = sessionStorage.getItem('connectionsToken');
    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const data = {
      vazao: valor,
    };

    try {
      await apiJalles.patch(`bomba/controle/${id}`, data, headerApi);
      toast.success('Comando Feito com sucesso', {
        position: 'top-right',
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
    } catch (error) {
    } finally {
      setModalVazao(false);
    }
  };

  return (
    <StyledModalVazao>
      <div className="conteiner">
        <RiCloseCircleFill onClick={() => setModalVazao(false)} className="closeModal" />
        <h2>Controle de Vazão</h2>

        <div className="inpultDiv">
          <label>Vazão: {valor}%</label>
          <input
            type="range"
            min="0"
            max="100"
            step="1"
            value={valor}
            onChange={(e) => setValor(Number(e.target.value))}
            className="inpulVazao"
          />
        </div>
        <button onClick={() => lidarButtonBomba(vazao[0])}>Enviar</button>
      </div>
    </StyledModalVazao>
  );
};
